<!-- NOT USED YET. NEEDS TO BE TESTED WHEN USED. -->
<div class="field-wrapper"
    [formGroup]="formGroup"
    [class.invalid]="!formGroup.controls[fieldKey].valid && formGroup.controls[fieldKey].touched">
  
  <div class="field-label">
    <label class="mb-0" style="font-weight: 500;">
      <!-- Don't place line spaces between components in the line below bc it will create a char space in the field label --> 
      {{field.label}}<span style="color:red" *ngIf="field.required">*</span><a *ngIf="field.instructions" class="intructionlink" title="{{field.instructions}}">?</a>:
    </label>
  </div>
  
  <div class="checkbox-container field-input">
    <mat-checkbox *ngFor="let item of field.choices | keyvalue"
                  [disabled]="formGroup.get(fieldKey)?.disabled"
                  [checked]="shouldBeSelected(item.key)"
                  [class.selected]='shouldBeSelected(item)' 
                  class="control control--checkbox" style="font-weight:normal; display: block; margin-bottom: 8px;"
                  (change)="itemChanged(item.key, $event.checked)">
      <span *ngIf="item.value.value" class="text">{{item.value.value}}</span>
      <span *ngIf="!item.value.value" class="text">{{item.value}}</span>
    </mat-checkbox>
  </div>
</div>
